import {lazy, Suspense, useMemo} from "react";

const PhoneInput = lazy(() => import("react-phone-number-input"));

function PhoneNumberInputFallback(props) {
    return (
        <input
            type={"tel"}
            className={"vel-input w-full !m-0 text-sm"}
            name={props.name}
            value={props.value ?? ""}
            required={props.required}
            disabled={props.disabled}
            placeholder={props.placeholder}
            autoComplete={"tel"}
            onChange={(event) => props.onChange?.(null, props.name, event.target.value)}
            data-error-message={props.errorMessage}
        />
    )
}

/**
 * Docs: https://catamphetamine.gitlab.io/react-phone-number-input/docs/index.html#phoneinputwithcountry
 * @returns {JSX.Element}
 * @constructor
 */
export default function PhoneNumberInput(props) {
    const value = useMemo(() => props.value, [props.value])
    
    return (
        <div className={"w-full relative"}>
            <Suspense fallback={<PhoneNumberInputFallback {...props} value={value}/>}>
                <PhoneInput
                    className={"flex flex-row vel-input"}
                    name={props.name}
                    value={value}
                    displayInitialValueAsLocalNumber={props.displayInitialValueAsLocalNumber}
                    required={props.required}
                    disabled={props.disabled}
                    placeholder={props.placeholder}
                    defaultCountry={props.defaultCountry}
                    numberInputProps={{className: "!m-0 !py-0 !px-0.5 !border-none text-sm"}}
                    countrySelectProps={{tabIndex: -1, unicodeFlags: true}}
                    onChange={(nextValue) => {
                        props.onChange(null, props.name, nextValue)
                    }}
                    data-error-message={props.errorMessage}
                />
            </Suspense>
        </div>
    )
}
